module.exports = __webpack_public_path__ + "static/media/info.e289965f.svg";